import { gql } from '@apollo/client';

const EducationHistoryFragment = gql`
  fragment EducationHistoryFragment on EducationHistory {
    id
    degreeName
    startDate
    endDate
    manuallyEdited
    university {
      id
      slug
      name
      logoUrl
      custom
      verified
      parent {
        slug
        name
        logoUrl
      }
    }
  }
`;

export default EducationHistoryFragment;
